import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, EnumDecoder, field, MapDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { MemberResponsibilityRecordBase } from './members/MemberResponsibilityRecord.js';
import { getPermissionLevelNumber, PermissionLevel } from './PermissionLevel.js';
import { PermissionRole } from './PermissionRole.js';
import { downgradeResourceKeys, PermissionsResourceKey, PermissionsResourceType, upgradeResourceKeys } from './PermissionsResourceType.js';
import { ResourcePermissions } from './ResourcePermissions.js';
export function getUnlistedResources(resourceType, permissions, listedResources) {
    const resources = permissions.resources.get(resourceType);
    if (!resources) {
        return [];
    }
    const result = [];
    for (const [id, resource] of resources) {
        if (id !== PermissionsResourceKey.All && id !== PermissionsResourceKey.CurrentPeriod && !listedResources.find(r => r.id === id)) {
            result.push({ id, name: resource.resourceName, type: resourceType });
        }
    }
    return result;
}
export class Permissions extends AutoEncoder {
    /**
     * Automatically have all permissions (e.g. when someone created a new group)
     * Also allows creating new groups
     */
    level = PermissionLevel.None;
    roles = [];
    responsibilities = [];
    /**
     * Mostly for temporary access
     */
    resources = new Map();
    static get full() {
        return Permissions.create({
            level: PermissionLevel.Full,
        });
    }
    hasRole(role) {
        return this.roles.find(r => r.id === role.id) !== undefined;
    }
    add(other) {
        if (getPermissionLevelNumber(this.level) < getPermissionLevelNumber(other.level)) {
            this.level = other.level;
        }
        for (const role of other.roles) {
            if (!this.roles.find(r => r.id === role.id)) {
                this.roles.push(role.clone());
            }
        }
        for (const responsibility of other.responsibilities) {
            if (!this.responsibilities.find(r => r.id === responsibility.id)) {
                this.responsibilities.push(responsibility.clone());
            }
        }
    }
    get isEmpty() {
        return this.level === PermissionLevel.None && this.roles.length === 0 && this.responsibilities.length === 0 && this.resources.size === 0;
    }
}
__decorate([
    field({ decoder: new EnumDecoder(PermissionLevel) })
], Permissions.prototype, "level", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(PermissionRole), version: 60 })
], Permissions.prototype, "roles", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(MemberResponsibilityRecordBase), version: 274 })
], Permissions.prototype, "responsibilities", void 0);
__decorate([
    field({
        decoder: new MapDecoder(new EnumDecoder(PermissionsResourceType), new MapDecoder(
        // ID
        StringDecoder, ResourcePermissions)),
        version: 249,
    }),
    field({
        decoder: new MapDecoder(new EnumDecoder(PermissionsResourceType), new MapDecoder(
        // ID
        StringDecoder, ResourcePermissions)),
        version: 418,
        upgrade: upgradeResourceKeys,
        downgrade: downgradeResourceKeys,
        upgradePatch: upgradeResourceKeys,
        downgradePatch: downgradeResourceKeys,
    })
], Permissions.prototype, "resources", void 0);
//# sourceMappingURL=Permissions.js.map